/** Must match backend/src/controllers/auth.controller.js PASSWORD_COMPLEXITY. */
export const PASSWORD_SPECIAL_CHARS = '@$!%*?&#^()[]-_+=.,:;';

export const PASSWORD_REQUIREMENTS_MESSAGE =
  'Password must be at least 8 characters and include: one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&#^()[]-_+=.,:;)';

const SPECIAL_RE = /[@$!%*?&#^()[\]\-_+=.,:;]/;

export function getPasswordChecks(password, confirmPassword) {
  const value = String(password || '');
  const confirm = confirmPassword == null ? '' : String(confirmPassword);
  return {
    minLength: value.length >= 8,
    uppercase: /[A-Z]/.test(value),
    lowercase: /[a-z]/.test(value),
    number: /\d/.test(value),
    special: SPECIAL_RE.test(value),
    match: Boolean(value) && Boolean(confirm) && value === confirm
  };
}

export function isPasswordComplex(password) {
  const checks = getPasswordChecks(password);
  return checks.minLength && checks.uppercase && checks.lowercase && checks.number && checks.special;
}

export function getPasswordRequirementError(password, confirmPassword) {
  const checks = getPasswordChecks(password, confirmPassword);
  if (!checks.minLength || !checks.uppercase || !checks.lowercase || !checks.number || !checks.special) {
    return PASSWORD_REQUIREMENTS_MESSAGE;
  }
  if (confirmPassword !== undefined && !checks.match) {
    return 'Passwords do not match';
  }
  return null;
}
